import { queryOptions } from '@tanstack/react-query'

import { fetchPlan, fetchPlans } from '#admin/features/platform/plans/api.ts'

export const plansQuery = () =>
  queryOptions({
    queryKey: ['platform', 'plans'],
    queryFn: ({ signal }) => fetchPlans(signal),
    staleTime: 30_000,
  })

export const planQuery = (planId: string) =>
  queryOptions({
    queryKey: ['platform', 'plans', planId],
    queryFn: ({ signal }) => fetchPlan(planId, signal),
    staleTime: 10_000,
  })
